
import { useParams } from 'react-router-dom';
import { SubrubrosFormState } from '../../../context/subrubros/SubrubrosFormState';
import { Form } from './form';

export const SubrubrosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Subrubro" : "Crear Subrubro";
  return (
    <SubrubrosFormState>
        <br />
        <Form title={title} />
    </SubrubrosFormState>
  );
};
